import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accessToken: localStorage.getItem('accessToken') || ''
};

export const AccessTokenSlice = createSlice({
  name: "AccessToken",
  initialState,
  reducers: {
    addAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },
  },
});
export const { addAccessToken } = AccessTokenSlice.actions;
export default AccessTokenSlice.reducer;
